// extracted by mini-css-extract-plugin
export default {"config":"Config_config__b3A1M"};